import { gql } from "../data/client";
import { EventHoursFragment, MapFragment, PageFragment } from "../data/schema";

export const BigGulpQuery = gql(`
  ${MapFragment}
  ${PageFragment}
  ${EventHoursFragment}

  query GetHeraldMap {
    announcements {
      id
      message(markdown: true)
      iconSrc
      iconColor
      onSchedule
      onScreens
      onWelcome
    }

    heraldMap {
     ...MapFragment
    }

    heraldHomePage {
      ...PageFragment
    }

    placeHoursGroups {
      id
      placeHours {
        startTime
        endTime
        weekdays
      }
    }

    heraldSchedule {
      id
      eventHours {
        ...EventHoursFragment
      }
    }

    events {
      id
      title
      description(markdown: true)
      graphic(auto: "format", w: 1200)
      type
      schedule {
        ...EventHoursFragment
      }
    }

    places {
      id

      title
      description(markdown: true)
      parentTitle
      canonicalStatus
      canonicalStatusNote
      overrideStatus
      overrideStatusNote
      overrideStatusExpiration
      graphic(auto: "format", w: 750)

      startTimeIsAmbiguous
      endTimeIsAmbiguous

      mapId
      parentId
      placeHoursGroupId
    }

    placeTypes {
      id
      label
      note
      iconSrc
      iconColor
      showPlaceParents

      parentId
      placeIds
    }

    heraldPages {
      id
      title
      url
      icon {
        id
        src
      }
    }
  }
`);
